import slimvue from "@/main";
import px2rem from "./px2rem";
import isMobile from "ismobilejs/dist/isMobile.min.js";

let loadPage = function(pcPage, wapPage) {
    if (isMobile.any) {
        slimvue.mount(wapPage);
        px2rem();
    } else {
        slimvue.mount(pcPage);
    }
};

export { loadPage };
